/**
 *
 * 获取当前模块的抽屉下拉框的配置
 * @param {*} active
 */
export function getDrawerOptionsList(active) {
  let options = {};
  switch (active) {
    case "myThread":
    case "allThread":
    case "threadPool":
    case "threadRecycle":
    case "threadShare":
      // 我的商机的抽屉的下拉框配置
      options = {
        allUser: [], // 所有用户
        areaList: [], // 所有片区
        sourceList: [], // 客户所有来源
        addedValueTaxTypeList: [], // 增值税类型
      };
      break;
    case "threadAllocation":
      // 我的商机的抽屉的下拉框配置
      options = {
        allUser: [], // 所有用户
        areaList: [], // 所有片区
        industryList: [], // 客户类型
        demandList: [], // 客户需求
        intentionLevelList: [], // 意向等级
        dealProductList: [], // 成交产品
        leadSourceList: [], // 线索来源
        noTransactionList: [], // 跟进卡点
        clueIntentionList: [
          {
            label: "新线索",
            value: "新线索",
          },
          {
            label: "有意向",
            value: "有意向",
          },
          {
            label: "无意向",
            value: "无意向",
          },
          {
            label: "已成交",
            value: "已成交",
          },
        ], // 线索意向
      };
      break;
    case "demandPublishPage":
      options = {
        allUser: [],
      };
      break;
    case "myDemandPage":
      options = {
        allUser: [],
      };
      break;
    case "myTaskPage":
      options = {
        allUser: [],
      };
      break;
    case "clientInfo":
    case "clientCheck":
    case "clientReady":
      // 客户资料的抽屉的下拉框配置
      options = {
        allUser: [], // 所有用户
        areaList: [], // 所有片区
        sourceList: [], // 客户所有来源
        addedValueTaxTypeList: [], // 增值税类型
        levelList: [], // 客户等级
        tipList: [], // 客户标签
        workList: [], // 日程事项
        qualificationList: "", // 资质类型
        lossReasonList: [], // 流失原因
        clientNumberList: [], // 客户编号
        contactPositionList: [], // 联系人职位
      };
      break;
    case "contractInfo":
    case "contractCheck":
    case "contractRenew":
    case "contractWork":
      // 全部合同的抽屉下拉框配置
      options = {
        allUser: [], // 所有用户
        areaList: [], // 所有片区
        sourceList: [], // 客户所有来源
        addedValueTaxTypeList: [], // 增值税类型
        levelList: "", // 客户等级
        tipList: "", // 客户标签
        productList: [], // 所有产品
        serviceTypeList: [], // 所有服务项类别
        serviceList: [], // 所有服务项
        quotaConfigList: [], // 限额区间
      };
      break;

    default:
      break;
  }

  return options;
}

/**
 * 获取各种标签数据
 */
export function getTagList(arrayList, type, companyId, this_) {
  const requestData = { type, companyId };

  // 定义类型映射关系
  const typeMapping = {
    合约主体: "SubjectContractList",
    收费定额: "turnoverList",
    片区: "areaList",
    客户来源: "sourceList",
    增值税类型: "addedValueTaxTypeList",
    客户等级: "levelList",
    客户标签: "tipList",
    资质类型: "qualificationList",
    流失原因: "lossReasonList",
    日程事项: "workList",
    代账情况: "accountOnBehalfList",
    联系人职位: "contactPositionList",
    意向等级: "intentionLevelList",
    共享商机类型: "threadShareTypeList",
    出访事由: "visitReasonList",
    客户类型: "industryList",
    客户需求: "demandList",
    成交产品: "dealProductList",
    线索来源: "leadSourceList",
    未成交原因: "noTransactionList",
  };

  this_.$request(
    "post",
    "/getTagList",
    requestData,
    (data) => {
      if (data.length === 0) {
        // 批量重置所有列表
        Object.keys(typeMapping).forEach((key) => {
          arrayList[typeMapping[key]] = [];
        });
      } else {
        data.forEach((element) => {
          const op = element.value.map((el) => {
            const d = {
              label: el.name,
              value: el.value,
            };

            // 特殊处理客户来源
            if (element.type === "客户来源") {
              d.value = el.name;
            }

            // 特殊处理资质类型
            if (element.type === "资质类型") {
              d.annualReminder = el.annualReminder;
              d.reminderDateOffset = el.reminderDateOffset;
            }

            return d;
          });

          // 根据类型映射赋值
          const targetKey = typeMapping[element.type];
          if (targetKey) {
            arrayList[targetKey] = op;
          }
        });
      }
    },
    (errorMessage) => {
      this_.$message.error(errorMessage);
    },
  );
}